import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { IconEnum, ICONS, IMG, ImgEnum, SaAssets } from '../models/assets.model';
import { LocalizationService } from './localization.service';

@Injectable({
	providedIn: 'root',
})
export class AssetsService {
	private static images: any = {};

	constructor(
		private localizationService: LocalizationService,
		private readonly matIconRegistry: MatIconRegistry,
		private readonly domSanitizer: DomSanitizer,
	) {
		this.registerFeedbackIcons();
		this.localizationService.domain$.subscribe((domain) => {
			this.registerIcons(domain);
			this.preloadImages(domain);
		});
	}

	public registerIcons(domain: string) {
		Object.values(ICONS).forEach((icon: SaAssets) => {
			let path = !!icon.brandSpecific
				? `/icons/${domain}/${icon.filename}`
				: `/icons/${icon.filename}`;
			this.matIconRegistry.addSvgIcon(
				icon.name,
				this.domSanitizer.bypassSecurityTrustResourceUrl(`${environment.assetUrl}${path}`),
			);
		});
	}

	private preloadImages(domain: string): void {
		Object.values(IMG).forEach((image: SaAssets) => {
			let path = !!image.brandSpecific
				? `/images/${domain}/${image.filename}`
				: `/images/${image.filename}`;
			AssetsService.images[image.name] = new Image();
			AssetsService.images[image.name].src = `${environment.assetUrl}${path}`;
			AssetsService.images[image.name].loading = 'lazy';
			AssetsService.images[image.name].decoding = 'async';
		});
	}

	private registerFeedbackIcons(): void {
		const baseUrl = `${environment.feedbackAssetUrl}/rate-icons`;
		const feedbackIcons: { name: IconEnum; filename: string }[] = [
			{ name: IconEnum.RATE_DISAPPOINTING, filename: 'ic_disappointing.svg' },
			{ name: IconEnum.RATE_DISAPPOINTING_C, filename: 'ic_disappointing_selected.svg' },
			{ name: IconEnum.RATE_NOT_GOOD, filename: 'ic_nogood.svg' },
			{ name: IconEnum.RATE_NOT_GOOD_C, filename: 'ic_nogood_colour.svg' },
			{ name: IconEnum.RATE_OK, filename: 'ic_ok.svg' },
			{ name: IconEnum.RATE_OK_C, filename: 'ic_ok_colour.svg' },
			{ name: IconEnum.RATE_GOOD, filename: 'ic_good.svg' },
			{ name: IconEnum.RATE_GOOD_C, filename: 'ic_good_colour.svg' },
			{ name: IconEnum.RATE_EXTRAORDINARY, filename: 'ic_satisfied.svg' },
			{ name: IconEnum.RATE_EXTRAORDINARY_C, filename: 'ic_satisfied_colour.svg' },
		];
		feedbackIcons.forEach((icon) => {
			this.matIconRegistry.addSvgIcon(
				icon.name,
				this.domSanitizer.bypassSecurityTrustResourceUrl(`${baseUrl}/${icon.filename}`),
			);
		});
	}

	getAssetSource(imageName: ImgEnum): string {
		return AssetsService.images[imageName].src;
	}
}
